/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:00a9341e-4af3-409b-a945-50eac60bccc6",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_Jjv85qhvq",
    "aws_user_pools_web_client_id": "2qrlr4tgs35o93eh12es3qs9n",
    "oauth": {},
    "aws_appsync_graphqlEndpoint": "https://n7bwgohpyvblnhewpssn7mihly.appsync-api.us-west-2.amazonaws.com/graphql",
    "aws_appsync_region": "us-west-2",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-gonscjbwnndlboyqg45xn2nwha",
    "aws_user_files_s3_bucket": "vonder165722-dev",
    "aws_user_files_s3_bucket_region": "us-west-2"
};


export default awsmobile;
